const UserMaintenanceScreens = {
  UserMaintenance: {
    PATH: '/user-maintenance',
    TITLE: 'User Maintenance',
    TITLE_ALT: 'User Maintenance',
    PERMISSION: 'USER_MAINTENANCE.read',
  },
  ViewUserMaintenance: {
    PATH: '/user-maintenance/view/:id',
    TITLE: 'User Maintenance',
    TITLE_ALT: 'Detail User Maintenance',
    PERMISSION: 'USER_MAINTENANCE.read',
  },
}

export default UserMaintenanceScreens
